import React from "react";

const ContactHome = ({
  width = 64,
  height = 64,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#2D96A7"
        fillOpacity="0.1"
        stroke="#2D96A7"
        strokeWidth="2"
      />
      <path
        d="M45.2937 40.4413C45.2937 40.9213 45.187 41.4146 44.9603 41.8946C44.7337 42.3746 44.4403 42.828 44.0537 43.2546C43.4003 43.9746 42.6803 44.4946 41.867 44.828C41.067 45.1613 40.2003 45.3346 39.267 45.3346C37.907 45.3346 36.4537 45.0146 34.9203 44.3613C33.387 43.708 31.8537 42.828 30.3337 41.7213C28.8003 40.6013 27.347 39.3613 25.9603 37.988C24.587 36.6013 23.347 35.148 22.2403 33.628C21.147 32.108 20.267 30.588 19.627 29.0813C18.987 27.5613 18.667 26.108 18.667 24.7213C18.667 23.8146 18.827 22.948 19.147 22.148C19.467 21.3346 19.9737 20.588 20.6803 19.9213C21.5337 19.0813 22.467 18.668 23.4537 18.668C23.827 18.668 24.2003 18.748 24.5337 18.908C24.8803 19.068 25.187 19.308 25.427 19.6546L28.5203 24.0146C28.7603 24.348 28.9337 24.6546 29.0537 24.948C29.1737 25.228 29.2403 25.508 29.2403 25.7613C29.2403 26.0813 29.147 26.4013 28.9603 26.708C28.787 27.0146 28.5337 27.3346 28.2137 27.6546L27.2003 28.708C27.0537 28.8546 26.987 29.028 26.987 29.2413C26.987 29.348 27.0003 29.4413 27.027 29.548C27.067 29.6546 27.107 29.7346 27.1337 29.8146C27.3737 30.2546 27.787 30.828 28.3737 31.5213C28.9737 32.2146 29.6137 32.9213 30.307 33.628C31.027 34.3346 31.7203 34.988 32.427 35.588C33.1203 36.1746 33.6937 36.5746 34.147 36.8146C34.2137 36.8413 34.2937 36.8813 34.387 36.9213C34.4937 36.9613 34.6003 36.9746 34.7203 36.9746C34.947 36.9746 35.1203 36.8946 35.267 36.748L36.2803 35.748C36.6137 35.4146 36.9337 35.1613 37.2403 35.0013C37.547 34.8146 37.8537 34.7213 38.187 34.7213C38.4403 34.7213 38.707 34.7746 39.0003 34.8946C39.2937 35.0146 39.6003 35.188 39.9337 35.4146L44.347 38.548C44.6937 38.788 44.9337 39.068 45.0803 39.4013C45.2137 39.7346 45.2937 40.068 45.2937 40.4413Z"
        stroke="#000929"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default ContactHome;
